export default {
  in(element) {
    let target = $(element.currentTarget);
    let message = target.attr('data-tooltip');
    let tooltip = $(`<span class="tooltip-icon">${message}</span>`);
    target.append(tooltip);
  },
  out(element) {
    let target = $(element.currentTarget);
    target.find('.tooltip-icon').remove();
  },
  addTooltip(element) {
    $(element).hover(this.in, this.out);
  },
  init() {
    $('[data-tooltip]').each((index, element) => {
      this.addTooltip(element);
    });
  },
};
